import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import ExpeditionDetail from '@components/ringil3/Features/Expedition/ExpeditionDetail';
import { useParams, useSearchParams } from 'react-router-dom';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import { PermissionTypesEnum } from '@api/ringil-api.v2.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';

interface ComponentProps {}

const ExpeditionTestPage: React.FC<ComponentProps> = () => {
  const { expeditionId } = useParams();
  const [searchParams] = useSearchParams();
  const { tr } = useTranslationLgs();

  const openMessages = searchParams.get('openMessages');
  const selectedCarrierId = searchParams.get('selectedCarrierId');

  return (
    <>
      <ResponsiveLayout
        title={tr('ExpeditionTestPage.detailExpedice', 'Detail expedice')}
        oneOfPermission={[
          PermissionTypesEnum.PERMISSION_EXPEDITION_DETAIL_TRANSPORTATIONTABS_READ,
          PermissionTypesEnum.PERMISSION_EXPEDITION_DETAIL_TRANSPORTATIONTABS_RW,
          PermissionTypesEnum.PERMISSION_EXPEDITION_DETAIL_TRANSPORTATIONTABS_READ_WITHOUTPRICE,
          PermissionTypesEnum.PERMISSION_EXPEDITION_MESSAGES_READ,
          PermissionTypesEnum.PERMISSION_EXPEDITION_MESSAGES_RW,
          PermissionTypesEnum.PERMISSION_EXPEDITION_DETAIL_TAB_SHIPMENT_READ,
          PermissionTypesEnum.PERMISSION_EXPEDITION_DETAIL_TAB_SHIPMENT_RW,
          PermissionTypesEnum.PERMISSION_EXPEDITION_DETAIL_TAB_CUSTOMS_READ,
          PermissionTypesEnum.PERMISSION_EXPEDITION_DETAIL_TAB_CUSTOMS_RW,
          PermissionTypesEnum.PERMISSION_EXPEDITION_DETAIL_TAB_INTERNALINFO_READ,
          PermissionTypesEnum.PERMISSION_EXPEDITION_DETAIL_TAB_INTERNALINFO_RW,
          PermissionTypesEnum.PERMISSION_EXPEDITION_DETAIL_TAB_CMR_READ,
          PermissionTypesEnum.PERMISSION_EXPEDITION_DETAIL_TAB_CMR_RW,
          PermissionTypesEnum.PERMISSION_EXPEDITION_DETAIL_TAB_CHAT_READ,
          PermissionTypesEnum.PERMISSION_EXPEDITION_DETAIL_TAB_CHAT_RW,
          PermissionTypesEnum.PERMISSION_EXPEDITION_DETAIL_ATTACHMENTS_READ,
          PermissionTypesEnum.PERMISSION_EXPEDITION_DETAIL_ATTACHMENTS_RW,
        ]}
      >
        <ExpeditionDetail expeditionId={expeditionId} openMessages={openMessages === 'true'} selectedCarrierId={selectedCarrierId ?? undefined} />
      </ResponsiveLayout>
    </>
  );
};

export default withAuthenticationRequired(ExpeditionTestPage);
